module.exports = __webpack_public_path__ + "img/vehicleIcon.af4f43b6.svg";